<template>

  <component :is="el" :label="label" :prop="prop" :required="required">

    <span v-if="noForm && showLabel">{{label}}</span>
    <el-time-select
        v-if="!disabled"
        :ref="ref"
        v-model="formData"
        :disabled="disabled"
        :placeholder="placeholder"
        :required="required"
        :picker-options="{
                start: startTime,
                step: step,
                end: endTime
              }"
        @change="updated">
    </el-time-select>
    <b v-else>{{formData}}</b>
  </component>

</template>

<script>

export default {
  name: 'time-input',

  props: {

    label: {
      type: String,
      default: 'Time'
    },

    showLabel: {
      type: Boolean,
      default: true
    },

    value: {
//      type: Date,
      required: true
    },

    disabled: {
      type: Boolean,
      default: false
    },

    startTime: {
      type: String,
      default: '06:00'
    },

    step: {
      type: String,
      default: '00:30'
    },

    endTime: {
      type: String,
      default: '20:00'
    },

/*
    format: {
      type: String,
      default: 'hh:mm a'
    },
*/

    required: {
      type: Boolean,
      default: false
    },

    options: {
      type: Object,
      default: null
    },

    placeholder: {
      type: String,
      default: null
    },

    helpText: {
      type: String,
      default: null
    },

    prop: {
      type: String,
      default: null
    },

    noForm: {
      type: Boolean,
      default: false
    }

  },


  methods: {

    updated (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }

  },

  watch: {

    value: function (val) {
      this.formData = val
    }

  },


  data () {
    return {
      ref: 'time-' + Date.now() + '-' + Math.random(),

      formData: this.value,

      el: this.noForm ? 'div' : 'el-form-item'
    }
  }
}
</script>



// WEBPACK FOOTER //
// TimeInput.vue?36c8c070